import { client } from "./index";

export const getMovies = (data) => client.get(`https://stagingott.etvwin.com/catalog_lists/${data.genere}.gzip?item_language=eng&region=${data.region}&auth_token=${data.auth}&access_token=${data.accessToken}&from=0&page=0&page_size=24&start_count=0`);

